export const MEMBERSHIP_BASE_PATH = '/operations/membership';

export const MEMBERSHIP_TABS = [
  { id: 'dashboard', label: 'Overview', path: MEMBERSHIP_BASE_PATH },
  { id: 'plans', label: 'Plans', path: `${MEMBERSHIP_BASE_PATH}/plans` },
  { id: 'memberships', label: 'Members', path: `${MEMBERSHIP_BASE_PATH}/members` },
  { id: 'transfers', label: 'Transfers', path: `${MEMBERSHIP_BASE_PATH}/transfers` },
  { id: 'reports', label: 'Reports', path: `${MEMBERSHIP_BASE_PATH}/reports` },
  { id: 'settings', label: 'Settings', path: `${MEMBERSHIP_BASE_PATH}/settings` },
  { id: 'tools', label: 'Tools', path: `${MEMBERSHIP_BASE_PATH}/tools` },
] as const;

export type MembershipTabId = (typeof MEMBERSHIP_TABS)[number]['id'];

export const msPageWrap =
  'flex h-[calc(100dvh-5.5rem)] max-h-[calc(100dvh-5.5rem)] min-h-0 flex-col overflow-hidden rounded-none border-0 bg-white sm:min-h-[480px] sm:rounded-xl sm:border sm:border-gray-200 dark:bg-gray-900 dark:sm:border-gray-700';

export const msShell = 'flex min-h-0 flex-1 overflow-hidden';

export const msMobileTabs =
  'flex shrink-0 gap-0 overflow-x-auto border-b border-gray-200 bg-[#f0f2f5] dark:border-gray-700 dark:bg-gray-900/80 [-webkit-overflow-scrolling:touch]';

export const msSubNavClass =
  'hidden w-14 shrink-0 flex-col items-center gap-1 overflow-y-auto border-r border-gray-200 bg-[#f0f2f5] py-3 dark:border-gray-700 dark:bg-gray-900/80 md:flex';

export const msSubNavItem = (active: boolean) =>
  `flex h-10 w-10 items-center justify-center rounded-xl transition-colors ${
    active
      ? 'bg-emerald-600 text-white shadow-sm'
      : 'text-gray-500 hover:bg-white hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'
  }`;

export const msInput =
  'rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 dark:border-gray-600 dark:bg-gray-800 dark:text-white';

export const msPrimaryBtn =
  'inline-flex items-center justify-center rounded-lg bg-emerald-600 px-3 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50';

export const msSecondaryBtn =
  'inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700';

export const msTableWrap =
  'overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700';

export const msTh = 'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500';
export const msTd = 'px-4 py-3 text-sm text-gray-800 dark:text-gray-200';

export function formatMembershipDateTime(value?: string | Date | null) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}
